import React, { useState, useEffect, useRef } from 'react';
import DataTable from '../../../Components/UiComponents/DataTable';
import { list } from '../../../Services/branchService';
import { Dialog } from 'primereact/dialog';
import MultiSelectElement from "../../../Components/UiComponents/MultiSelectElement";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import { getCustomerFields2, getCustomerFields } from '../../../Services/fieldsServices';
import { getBranchUser } from '../../../Services/userService';
import { filter } from '../../../Services/clientService';
import { getModulePermissions } from '../../../Services/pricingPlanService';
import HeaderSearchBar from '../../../Components/UiComponents/HeaderSearch';
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import { multiDelete } from '../../../Services/clientService';
import 'react-toastify/dist/ReactToastify.css';
import { getStages } from '../../../Services/optionService';
import CreateNewStakeHolder from './CreateNewStakeHolder';
import { useNavigate } from 'react-router-dom';
import { get } from '../../../Services/customerServices';
import _ from 'lodash';
import { InputIcon } from "primereact/inputicon";
import Loader from '../../../Components/UiComponents/Loader';
import { getField } from '../../../Services/tooltipService';
import { useStakeholder } from "../../../Providers/StakeholderContext";
import SingleSelectElement from '../../../Components/UiComponents/SingleSelectElement';
import PlaylistVideos from '../../../Components/Videos/PlaylistVideos';

export default function StakeHolderList(props) {
    const toastRef = useRef();
    const [loading, setLoading] = useState(false);
    const [customerId, setCustomerId] = useState(null);
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('center');
    const [searchQuery, setSearchQuery] = useState("");
    const [stages, setStages] = useState([]);
    const [updatedReferenceData, setUpdatedReferenceData] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [searchedLength, setSearchedLength] = useState(0);
    const [planId, setPlanId] = useState(null);
    const [branchId, setBranchId] = useState(null);
    const [branch, setBranch] = useState({});
    const [stakeHolderDetails, setStakeHolderDetails] = useState([]);
    const [branchDetails, setBranchDetails] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [filterStakeHolderDetails, setFilterStakeHolderDetails] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState([]);
    const [custmerDetails, setCustmerDetails] = useState({});
    const [branchDetail, setBranchDetail] = useState([]);
    const [customerTableData, setCustomerTableData] = useState([]);
    const [ids, setIds] = useState([]);
    const [customerIds, setCustomerIds] = useState([]);
    const [customerData, setCustomerData] = useState();
    const [versions, setVersions] = useState([]);
    const [shortName, setShortName] = useState('');
    const [currVersion, setCurrVersion] = useState('');
    const [filterData, setFilterData] = useState([]);
    const [clientType, setClientType] = useState([]);
    const [sectorType, setSectorType] = useState([]);
    const [clientClassificationType, setClientClassificationType] = useState([]);
    const [clientClassificationV3Type, setClientClassificationV3Type] = useState([]);
    const [relationshipOwnerType, setRelationshipOwnerType] = useState([]);
    const [boardSponsorType, setBoardSponsorType] = useState([]);
    const [countryListType, setCountryListType] = useState([]);
    const [businessUnitType, setBusinessUnitType] = useState([]);
    const [regionType, setRegionType] = useState([]);
    const [selectedStakeholder, setSelectedStakeholder] = useState([]);
    const [selectedStakeholderId, setSelectedStakeholderId] = useState([]);
    const [selectedClassification, setSelectedClassification] = useState([]);
    const [selectedClassificationId, setSelectedClassificationId] = useState([]);
    const [selectedBoardSponser, setSelectedBoardSponser] = useState([]);
    const [selectedBoardSponserId, setSelectedBoardSponserId] = useState([]);
    const [selectedSector, setSelectedSector] = useState([]);
    const [selectedSectorId, setSelectedSectorId] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedStatusId, setSelectedStatusId] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState([]);
    const [selectedOwnerId, setSelectedOwnerId] = useState();
    const [selectedFavourites, setSelectedFavourites] = useState('All');
    const [favouriteStatus, setFavouriteStatus] = useState([]);
    const [selectedBuId, setSelectedBuId] = useState([]);
    const [selectedBu, setSelectedBu] = useState([]);
    const [selectedRegionId, setSelectedRegionId] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState([]);
    const [favourites, setFavourites] = useState([
        { label: 'All', value: 'All' },
        { label: 'Favourites', value: 'Favourites' },
    ]);
    const [relationshipOwner, setRelationshipOwner] = useState([])
    const [branchIdFromLS, setBranchIdFromLS] = useState()
    const [projectSumFields, setProjectSumFields] = useState([]);
    const [commanFieldsNew, setCommanFieldsNew] = useState([]);
    const [clientFieldsNew, setClientFieldsNew] = useState([]);
    const [clientSectionsNew, setClientSectionsNew] = useState([]);
    const [clientSumFields, setClientSumFields] = useState([]);
    const [clientFieldsProject, setClientFieldsProject] = useState([]);
    const [clientFieldsRDS, setClientFieldsRDS] = useState([]);
    const [clientFiltersNew, setClientFiltersNew] = useState([]);
    const [commonFields, setCommonFields] = useState([]);
    const [currency, setCurrency] = useState('');
    const [havingBranch, setHavingBranch] = useState(false);
    const [columns, setColumns] = useState([])
    const [filterPermissions, setFilterPermissions] = useState({})
    const [totalRecords, setTotalRecords] = useState(0);
    const [moduleNames, setModuleNames] = useState([])
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: -1,
        sortField: 'client_name',
        sortOrder: 1
    });
    
    const userprivileges = localStorage.getItem("user_privileges");
    if (userprivileges) {
        var tmpPrivilege = JSON.parse(userprivileges);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var clientPrivilege = tmpPrivilege[0].client_readwrite;
        }
    }

    const [deleted, setDeleted] = useState(false)
    const [showVideo, setShowVideo] = useState(false);
    const { setGlobalStakeholderData } = useStakeholder();
    const navigate = useNavigate();

    useEffect(() => {
        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);

            // Extracting customer information from end user data
            const customer = enduser.customer;
            // Setting customer ID state
            setCustomerId(customer);
            const branch = enduser.branch;
            setBranchIdFromLS(branch)
        } else {
            navigate("/login")
            localStorage.clear()
        }

        // Fetching stage data
        getStage();

    }, []);

    useEffect(() => {
        if (deleted) {
            setDeleted(false);
            setIds([]);
            setUpdatedReferenceData([])
        }
    }, [deleted])

    useEffect(() => {
        // if (lazyParams) {
        getStatkeHolderDetails();
        // }
    }, [lazyParams]);

    useEffect(() => {
        if (customerId) {
            getCustomer();
            getFieldData()

        }
    }, [customerId])

    useEffect(() => {
        setGlobalStakeholderData(null)
    }, [])

    useEffect(() => {
        // Fetching branch field data
        getBranchList();
        // getCustomer();
        // Fetching customer control data
        getCustomerFieldDetails();
        getCurrentVersion();
    }, [versions]);

    useEffect(() => {
        getBranchUsers();
    }, [branchId]);

    useEffect(() => {
        getPermission();
    }, [planId]);

    useEffect(() => {
        getStatkeHolderDetails();
    }, [branch, selectedBranchId, selectedStakeholderId, selectedClassificationId,
        selectedBoardSponserId, selectedSectorId, selectedStatusId, selectedOwnerId, selectedFavourites, selectedBuId, selectedRegionId]);


    useEffect(() => {
        var cols = [
            // Column configuration for the "Question" field
            {
                field: "client_name", // Data field to map from the row data
                header: headerName, // Header label for the column
                body: checkingDisplayName, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Field" field
            {
                field: "client_seq", // Data field to map from the row data
                header: headerId, // Header label for the column
                body: appliedByTemplate, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Referred" field
            {
                field: "client_type", // Data field to map from the row data
                header: headerType, // Header label for the column
                body: approverTemplate, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Stakeholder Status" field
            {
                field: "client_status", // Data field to map from the row data
                header: headerStatus, // Header label for the column
                body: stakeholderStatus, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Stakeholder ESG Preview Score" field
            {
                field: "rds.rds_score", // Data field to map from the row data
                header: headerScore, // Header label for the column
                body: esgPreviewScore, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Stakeholder Classification" field
            {
                field: "client_classification", // Data field to map from the row data
                header: headerClassification, // Header label for the column
                body: clientClassification, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Sector" field
            {
                field: "sector", // Data field to map from the row data
                header: headerSector, // Header label for the column
                body: sector, // Custom renderer for the cell content
                style: { width: '40px' },
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Main Board Sponsor" field
            {
                field: "main_board_sponsor", // Data field to map from the row data
                header: headerSponsor, // Header label for the column
                body: mainBoardSponser, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Total Budget" field
            {
                field: "total_value_for_projects", // Data field to map from the row data
                header: headerBudget, // Header label for the column
                body: totalBudget, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Next Review" field
            {
                field: "next_review", // Data field to map from the row data
                header: headerReview, // Header label for the column
                body: nextReview, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            // Column configuration for the "Stakeholder Alert Flag" field
            {
                field: "client_alert_flag", // Data field to map from the row data
                header: headerAlert, // Header label for the column
                body: stakeholderAlert, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true

            }
        ]
        setColumns(cols)
    }, [stakeHolderDetails, filterPermissions])

    useEffect(() => {
        if (props.visible) {
            setVisible(true)
            setPosition('right')
        }
    }, [props.visible]);


    const getFieldData = async () => {
        setLoading(true);
        try {
            const response = await getField(customerId);

            // Check if the response is valid
            if (response && response.data) {
                const clientModuleData = response.data;

                // Safely access modules and their sub-modules
                const cust = clientModuleData.cust[0];

                if (cust && Array.isArray(cust.modules)) {
                    setModuleNames(cust.modules);

                    const projectModules = _.find(cust.modules, { module_name: "Pipeline", status: true });
                    if (projectModules) {
                        setProjectSumFields(_.find(projectModules.sub_modules, { sub_module_name: "Summary" })?.fields || []);
                    }

                    const commonModules = _.find(cust.modules, { module_name: "Common Fields", status: true });
                    if (commonModules) {
                        setCommanFieldsNew(_.find(commonModules.sub_modules, { sub_module_name: "Common Fields" })?.fields || []);
                    }

                    const clientModules = _.find(cust.modules, { module_name: "Clients", status: true });
                    if (clientModules) {
                        setClientFieldsNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW" })?.fields || []);
                        setClientSectionsNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW" })?.sections || []);
                        setClientSumFields(_.find(clientModules.sub_modules, { sub_module_name: "Summary" })?.fields || []);
                        setClientFieldsProject(_.find(clientModules.sub_modules, { sub_module_name: "Project" })?.fields || []);
                        setClientFieldsRDS(_.find(clientModules.sub_modules, { sub_module_name: "Relationship Development Score" })?.fields || []);
                        setClientFiltersNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW" })?.filters || []);
                    }

                    const commonFieldModules = _.find(cust.modules, { module_name: "Common Fields" });
                    if (commonFieldModules) {
                        setCommonFields(_.find(commonFieldModules.sub_modules, { sub_module_name: "Common Fields" })?.fields || []);
                    }
                }
            }
        } catch (error) {
            // Handle errors gracefully
            toastRef.current.showToast({
                type: "error",
                message: "Failed to load field data. Please try again later."
            });
        } finally {
            setLoading(false);
        }
    };


    // Function to get customer reference data.
    const getCustomer = async () => {
        try {
            setLoading(true);

            if (customerId) {
                // Fetch customer data
                const customer = await get(customerId);

                // Check if the response is valid
                if (customer && customer.data) {
                    setCustomerData(customer.data);

                    const cusData = customer.data;
                    let versions = [];

                    // Loop through data.version_maintained array
                    for (let i = 0; i < cusData.version_maintained.length; i++) {
                        // Check if module_name is 'Client'
                        if (cusData.version_maintained[i].module_name === 'Client') {
                            // Assign version_detail to versions array
                            versions = cusData.version_maintained[i].version_detail;
                            break; // Exit loop after finding the module_name 'Client'
                        }
                    }

                    // Update state with the found versions and short name
                    setVersions(versions);
                    setShortName(cusData.customer_short);
                } else {
                    // Handle case where customer data is not valid
                    toastRef.current.showToast({
                        type: "error",
                        message: "Failed to fetch customer data. Please try again.",
                    });
                }
            }
        } catch (error) {
            // Handle errors during the API request
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred while fetching customer data. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false);
        }
    };


    // Function to fetch and set stages data
    const getStage = async () => {
        setLoading(true);
        try {
            // Fetch stages data from API
            const stagesResponse = await getStages();

            // Extract and set stages data
            if (stagesResponse && stagesResponse.data) {
                setStages(stagesResponse.data[0].option_choice);
            } else {
                toastRef.current.showToast({
                    type: "warning",
                    message: "No stages data found. Please try again later.",
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "Failed to fetch stages data. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false);
        }
    };


    // Function to fetch and set stages data
    const getStatkeHolderDetails = async () => {
        try {
            setLoading(true)
            // Fetch stages data from API
            //(skip, limit, cust_id, branch, pattern, sortBy, orderBy, filterData, searchVal)
            if (branch?.branch_id) {
                const { first, rows, sortField, sortOrder } = lazyParams;
                let data = {
                    skip: first,
                    limit: rows,
                    cust_id: customerId,
                    branch: branch,
                    pattern: searchQuery || '',
                    sortBy: sortField,
                    orderBy: sortOrder,
                    filterData: {
                        branch_id: selectedBranchId.length !== 0 ? selectedBranchId : [],
                        client_classification: selectedClassificationId.length !== 0 ? selectedClassificationId : [],
                        relationship_owner: [],
                        client_type: selectedStakeholderId.length !== 0 ? selectedStakeholderId : [],
                        sector: selectedSectorId.length !== 0 ? selectedSectorId : [],
                        stakeholder_status: selectedStatusId.length !== 0 ? selectedStatusId : [],
                        business_unit: selectedBuId.length !== 0 ? selectedBuId : [],
                        region: selectedRegionId.length !== 0 ? selectedRegionId : [],
                        main_board_sponsor: selectedBoardSponserId.length !== 0 ? selectedBoardSponserId : [],
                        filter: selectedFavourites !== '' ? selectedFavourites : "All",
                    }
                }

                const stakeholderDetail = await filter(data.skip, data.limit, data.cust_id, data.branch, data.pattern, data.sortBy, data.orderBy, data.filterData);
                if (stakeholderDetail && stakeholderDetail.data) {
                    setLoading(false)
                    setStakeHolderDetails(stakeholderDetail?.data?.client)
                    setFilterStakeHolderDetails(stakeholderDetail?.data?.client)
                    setTotalRecords(stakeholderDetail?.data?.count);
                }

            }
        } catch (error) {
            // Handle any errors that occurred during the API calls
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or contact Admin.'
            });
        }
    };


    // Function to fetch customer fields data from the server
    const getBranchList = async () => {
        // Ensure customerId is not null
        if (customerId !== null) {
            try {
                // 
                // Fetch customer data from the server
                const customerDataResponse = await list(customerId, 'branch_name', -1);

                // Check if the response contains data
                if (customerDataResponse && customerDataResponse.data) {
                    setBranchDetails(customerDataResponse.data.branch);
                    setBranchId(customerDataResponse.data.branch[0]?._id);
                } else {
                    toastRef.current.showToast({
                        type: "warning",
                        message: "No branch data found.",
                    });
                }
            } catch (error) {
                // Log and notify if there's an error fetching customer data
                console.error("Error fetching branch fields:", error);
                toastRef.current.showToast({
                    type: "error",
                    message: "Failed to fetch branch list. Please try again or contact Admin.",
                });
            }
        }

        // }
    };


    const getFilterPermissions = (customerDataResponse) => {
        var filterPermission = {};
        _.filter(customerDataResponse.filters, function (filter) {
            filterPermission[filter.filter] = filter.status;
        })
        setFilterPermissions(filterPermission)
    }

    // Function to fetch customer fields data from the server
    const getPermission = async () => {
        // Ensure customerId is not null
        if (customerId !== null) {
            setLoading(true); // Start loading spinner

            try {
                // Fetch customer data from the server
                const customerDataResponse = await getModulePermissions(planId, 'Clients');

                // Check if the response is valid and contains status
                if (customerDataResponse && customerDataResponse.data && customerDataResponse.data.status) {
                    getFilterPermissions(customerDataResponse.data);

                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: 'No permissions found or invalid response.',
                    });
                }

            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to fetch permissions. Please try again or contact Admin.',
                });
            } finally {
                setLoading(false);
            }
        }
    };


    // Function to fetch customer fields data from the server
    const getBranchUsers = async () => {
        // Ensure customerId and branchIdFromLS are not null
        if (customerId !== null && branchIdFromLS !== null) {
            setLoading(true); // Start loading spinner

            try {
                // Fetch customer data from the server
                const customerDataResponse = await getBranchUser(customerId, branchIdFromLS.branch_id);

                if (customerDataResponse && customerDataResponse.data) {
                    // Update state with branch and relationship owners
                    setBranch(customerDataResponse.data[0]?.branch);
                    setBranchDetail(customerDataResponse.data);

                    const relation = customerDataResponse.data.map((o) => ({
                        _id: o._id,
                        label: o.firstname + " " + o.surname,
                        status: o.status,
                    }));

                    setRelationshipOwner(relation);

                } else {
                    toastRef.current.showToast({
                        type: 'warning',
                        message: 'No data found for the specified branch.',
                    });
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to fetch branch users. Please try again or contact Admin.',
                });
            } finally {
                setLoading(false);
            }
        }
    };




    // Function to fetch and set customer control fields data
    const getCustomerFieldDetails = async () => {
        // Check if customerId is available
        if (customerId !== null) {
            try {
                // Fetch customer control field data

                const customerData = await getCustomerFields2(customerId);
                if (customerData && customerData.data) {
                    setCustomerTableData(customerData?.data?.cust[0]?.modules)
                    let Stakeholder = _.find(customerData?.data?.cust[0]?.modules, { module_name: "Clients" }).sub_modules
                    if (Stakeholder) {
                        let clientFiltersNew = _.find(Stakeholder, { sub_module_name: "NEW" }).filters;
                        setFilterData(clientFiltersNew)
                    }
                }

            } catch (error) {
                // Handle any errors that occurred during the API calls
                toastRef.current.showToast({
                    type: 'error',
                    message: 'An error occurred. Please try again or contact Admin.'
                });

            }
        }
        if (customerId !== null) {
            try {

                const customerData = await getCustomerFields(customerId) // Reference
                if (customerData && customerData.data) {
                    setPlanId(customerData.data.pricing_plan)
                    setCustmerDetails(customerData?.data)
                    setCurrency(customerData.data.currency);
                    setHavingBranch(customerData.data.havingBranch)
                }


                if (customerData.data.havingBranch) {
                    var newColumn = {
                        field: "Branch Name", // Data field to map from the row data
                        header: "Branch Name", // Header label for the column
                        body: branchName, // Custom renderer for the cell content
                        headerClassName: "header-datatable white-space",
                        className: 'row-datatable'
                    }

                    setColumns([...columns, newColumn]);
                }
                let data = customerData?.data.reference_data;

                if (customerData?.data.reference_data && data.length !== 0) {
                    const clientTypeData = data.find(
                        (item) => item.option_names === "clientTypeV1"
                    );
                    if (clientTypeData && clientTypeData?.option_choice) {
                        const activeOptions = clientTypeData.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setClientType(activeOptions);
                    }

                    const sectorData = data.find((item) => item.option_names === "SectorV1");
                    if (sectorData && sectorData?.option_choice) {
                        const activeOptions = sectorData.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setSectorType(activeOptions);
                    }

                    const ClientClassification = data.find(
                        (item) => item.option_names === "ClientClassificationV1"
                    );
                    if (ClientClassification && ClientClassification?.option_choice) {
                        const activeOptions = ClientClassification.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setClientClassificationType(activeOptions);
                    }

                    const ClientClassificationV3 = data.find(
                        (item) => item.option_names === "ClientClassificationV3"
                    );
                    if (ClientClassificationV3 && ClientClassificationV3?.option_choice) {
                        const activeOptions = ClientClassificationV3.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setClientClassificationV3Type(activeOptions);
                    }
                    const relationshipOwner = data.find(
                        (item) => item.option_names === "RelationshipOwner"
                    );
                    if (relationshipOwner && relationshipOwner?.option_choice) {
                        const activeOptions = relationshipOwner.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setRelationshipOwnerType(activeOptions);
                    }

                    const boardSponsor = data.find(
                        (item) => item.option_names === "BoardSponsor"
                    );
                    if (boardSponsor && boardSponsor?.option_choice) {
                        const activeOptions = boardSponsor.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setBoardSponsorType(activeOptions);
                    }

                    const countryList = data.find(
                        (item) => item.option_names === "CountryList"
                    );
                    if (countryList && countryList?.option_choice) {
                        const activeOptions = countryList.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setCountryListType(activeOptions);
                    }

                    const businessUnit = data.find(
                        (item) => item.option_names === "BusinessUnit"
                    );
                    if (businessUnit && businessUnit?.option_choice) {
                        const activeOptions = businessUnit.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setBusinessUnitType(activeOptions);
                    }

                    const region = data.find((item) => item.option_names === "Region");
                    if (region && region?.option_choice) {
                        const activeOptions = region.option_choice.filter(
                            (option) => option.status === "active"
                        );
                        setRegionType(activeOptions);
                    }
                }
            } catch (error) {
                // Handle any errors that occurred during the API calls
                toastRef.current.showToast({
                    type: 'error',
                    message: 'An error occurred. Please try again or contact Admin.'
                });
            }
        }
    };



    /**
   * Function to check and render the display name or option names based on availability in the row data.
   * @param {Object} rowData - The data of the row being rendered.
   * @returns {JSX.Element} - The JSX element containing the display name or option names.
   */
    const checkingDisplayName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.client_name != null && rowData.client_name !== '') {
            // If display name doesn't exist or is empty, render option names
            return (
                <div className="form-label-text text-left mr-20 pointer mar-l-5">{rowData.client_name}</div>
            );
        }
    };

    // This function returns a React component that displays whether the row data has a weightage or not.
    const appliedByTemplate = (rowData) => {
        // Return the JSX to display the text
        return (
            <div>
                <div>{rowData.client_seq}</div>
            </div>
        );
    };

    /**
   * Template function for rendering approval status icons based on rowData.option_status.
   * @param {Object} rowData - Data of the current row.
   * @returns {JSX.Element} - JSX element representing the approval status icon.
   */
    const branchName = (rowData) => {

        // Return JSX element with appropriate icon and color
        return (
            <div>
                <div>{rowData?.branch_name ? rowData?.branch_name : ''}</div>
            </div>
        );
    };

    const stakeholderStatus = (rowData) => {

        // Return JSX element with appropriate icon and color
        return (
            <div>
                <div>{rowData?.client_status ? rowData?.client_status : ''}</div>
            </div>
        );
    };

    const approverTemplate = (rowData) => {
        if (!rowData || !Array.isArray(rowData.client_type)) {
            return null;
        }

        const listItems = rowData.client_type.map((type, index) => {
            return (
                <li key={index}>{type.label} {
                    rowData.client_type.length - 1 === index ? null : <span>,</span>
                }</li>
            );
        });

        return (
            <ul className='list-height'>
                {listItems}
            </ul>
        );
    };

    const esgPreviewScore = (rowData) => {

        // Return JSX element with appropriate icon and color
        return (
            <div>
                <div>{rowData?.rds?.rds_score ? rowData?.rds?.rds_score : 0}</div>
            </div>
        );
    };
    const clientClassification = (rowData) => {
        if (!rowData || !Array.isArray(rowData.client_classification)) {
            return null;
        }

        const listItems = rowData.client_classification.map((classification, index) => {
            return (
                <li key={index}>{classification.label} {
                    rowData.client_classification.length - 1 === index ? null : <span>,</span>
                }</li>
            );
        });

        return (
            <ul className='list-height'>
                {listItems}
            </ul>
        );
    };
    const sector = (rowData) => {
        if (!rowData || !Array.isArray(rowData.sector)) {
            return null;
        }

        const listItems = rowData.sector.map((sec, index) => {
            return (
                <li key={index}>{sec.label} {
                    rowData.sector.length - 1 === index ? null : <span>,</span>
                }</li>
            );
        });

        return (
            <ul className='list-height'>
                {listItems}
            </ul>
        );
    };
    const mainBoardSponser = (rowData) => {

        // Return JSX element with appropriate icon and color
        return (
            <div>
                <div>{rowData?.main_board_sponsor ? rowData?.main_board_sponsor : ''}</div>
            </div>
        );
    };
    const totalBudget = (rowData) => {

        // Return JSX element with appropriate icon and color
        return (
            <div>
                <div>{rowData?.total_value_for_projects ? rowData?.total_value_for_projects : ''}</div>
            </div>
        );
    };
    const nextReview = (rowData) => {
        const date = new Date(rowData?.next_review);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        // Return JSX element with appropriate icon and color
        return (
            <div>
                <div>{rowData?.next_review ? `${day}-${month}-${year}` : ''}</div>
            </div>
        );
    };
    const stakeholderAlert = (rowData) => {
        // Return JSX element with appropriate icon and color
        return (

            <div>
                {/* <div>{rowData?.client_alert_flag?.radio ? rowData?.client_alert_flag?.radio : ''}</div> */}
                <InputIcon
                    className={
                        rowData?.client_alert_flag?.radio === "yes"
                        && "pi pi-bullseye"
                    }
                    style={{ color: 'red' }}
                />
            </div>
        );
    };

    const headerName = () => {
        return _.find(clientFieldsNew, { field_name: 'Client Name' })?.display_name
    }

    const headerId = () => {
        return _.find(clientFieldsNew, { field_name: 'Client ID' })?.display_name
    }

    const headerType = () => {
        return _.find(clientFieldsNew, { field_name: 'Client Type' })?.display_name
    }

    const headerStatus = () => {
        return _.find(clientFieldsNew, { field_name: 'Client Status' })?.display_name
    }

    const headerScore = () => {
        return _.find(clientFieldsRDS, { field_name: 'Relationship Development Score' })?.display_name
    }

    const headerClassification = () => {
        return _.find(clientFieldsNew, { field_name: 'Client Classification' })?.display_name
    }

    const headerSector = () => {
        return _.find(commanFieldsNew, { field_name: 'Sector' })?.display_name
    }

    const headerSponsor = () => {
        return _.find(commanFieldsNew, { field_name: 'Main Board Sponsor' })?.display_name
    }

    const headerBudget = () => {
        return _.find(clientFieldsProject, { field_name: 'Total Value' })?.display_name
    }

    const headerReview = () => {
        return _.find(commanFieldsNew, { field_name: 'Next Review' })?.display_name
    }

    const headerAlert = () => {
        return _.find(clientSumFields, { field_name: 'Client Alert Flag' })?.display_name
    }

    const show = (position) => {
        if (clientPrivilege) {
            setPosition(position);
            setVisible(true);
        } else {
            toastRef.current.showToast({
                type: 'error',
                message: "Permission Denied"
            });
        }
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e);
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        // filteredQuestionsArray(e.target.value)
    };
    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        filteredQuestionsArray("");
    };

    /**
    * Filters the customer reference data based on the provided query.
    * If the query is empty, it retrieves the full customer field data.
    * 
    * @param {string} query - The search query to filter the customer reference data.
    */

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getStatkeHolderDetails();
            setSearchedLength(lowerCaseQuery.length); // Update the searched length after resetting the data


        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterStakeHolderDetails.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    return value.toString().toLowerCase().includes(lowerCaseQuery);
                });
            });

            // Update the state with the filtered data
            setStakeHolderDetails(filteredData);

        }
    }


    const handleHide = () => {
        setVisible(false);
        getStatkeHolderDetails();
        if (props.visible) {
            props.hidePopUp(false)
        }
    }

    const confirmDeleteProduct = () => {
        setDeleteProductDialog(true);
    };

    const deleteField = async () => {
        try {
            setLoading(true)
            const response = await multiDelete(ids, customerId);
            if (response && response.status === 200) {
                toastRef.current.showToast({
                    type: 'warn',
                    message: `${response.data.message} Successfully`
                });
                setDeleted(true)
                setUpdatedReferenceData([]);
                setDeleteProductDialog(false);
                getStatkeHolderDetails();
            }
            setLoading(false);

        } catch (error) {
            // Handle any errors that occurred during the API calls
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or contact Admin.'
            });
        }
    }

    /**
    * Removes a field from the customer reference data at the specified index.
    * @param {number} selectedIndex - The index of the field to be removed.
    * @param {Object} data - The updated data to be set after removal.
    */
    const removeField = async (selectedIndex, data) => {
        const ids = [];
        const customerIds = [];

        data.forEach(item => {
            ids.push(item._id);
            customerIds.push(item.customer_id);
        });
        setIds(ids)
        setCustomerIds(customerIds)
        setUpdatedReferenceData(data);
    };

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };


    // Define the footer for the delete product dialog with action buttons
    const deleteProductDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
                </div>
            </div>
        );
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown)
    }

    const resetFilter = () => {
        setSelectedBranch([])
        setSelectedBranchId([])
        setSelectedStakeholder([])
        setSelectedStakeholderId([])
        setSelectedClassification([])
        setSelectedClassificationId([])
        setSelectedSector([])
        setSelectedSectorId([])
        setSelectedBoardSponser([])
        setSelectedBoardSponserId([])
        setSelectedBu([])
        setSelectedBuId([])
        setSelectedRegion([])
        setSelectedRegionId([])
        setSelectedStatus([])
        setSelectedStatusId([])
        setSelectedOwner([])
        setSelectedOwnerId([])
        setFavouriteStatus([])
        setSelectedFavourites('All')
        setShowDropdown(false)
        getStatkeHolderDetails()
    }

    const handleSelection = (event) => {
        setSelectedBranch(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item._id);
        setSelectedBranchId(ids);

    };

    const handleStakeholderSelection = (event) => {
        setSelectedStakeholder(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedStakeholderId(ids);

    };
    const handleClassificationSelection = (event) => {
        setSelectedClassification(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedClassificationId(ids);
    }

    const handleSectorSelection = (event) => {
        setSelectedSector(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedSectorId(ids);
    }

    const handleBoardSponserSelection = (event) => {
        setSelectedBoardSponser(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedBoardSponserId(ids);
    }
    const handleBUSelection = (event) => {
        setSelectedBu(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedBuId(ids);
    }

    const handleRegionSelection = (event) => {
        setSelectedRegion(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedRegionId(ids);
    }

    const handleStatusSelection = (event) => {
        setSelectedStatus(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedStatusId(ids);
    }
    const handleFavouritesSelection = (event) => {
        setFavouriteStatus(event);
        setSelectedFavourites(event);
    }

    const handleOwnerSelection = (event) => {
        setSelectedOwner(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item.label);
        setSelectedOwnerId(ids);
    }

    // Define getCurrentVersion function
    const getCurrentVersion = () => {
        // Use filter function to find matching version
        const ver = versions;
        const found = ver.filter(version => version.checked === true);
        // Update currVersion if a match is found
        if (found.length > 0) {
            setCurrVersion(found[0].folder);
        } else {
            // Handle case where no match is found (optional)
        }
    };

    const editDirect = (rowData) => {
        if (clientPrivilege) {
            if (rowData._id && rowData.client_name) {
                navigate(`/stakeholder/${rowData._id}/${shortName}/${currVersion}`, { state: { clientName: rowData.client_name } });
            }
        } else {
            toastRef.current.showToast({
                type: 'error',
                message: "Permission Denied"
            });
        }
    };

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };


    const onSort = (e) => {
        let newSortField = e.sortField;
        let newSortOrder = e.sortOrder;

        // Check if the same column is clicked
        if (lazyParams.sortField === newSortField) {
            // If currently sorted ascending, switch to descending
            if (lazyParams.sortOrder === 1) {
                newSortOrder = -1; // Set to descending
            }
            // If currently sorted descending, remove sorting
            else if (lazyParams.sortOrder === -1) {
                newSortField = null; // Remove sorting
                newSortOrder = -1; // Remove sorting
            }
        }
        setLazyParams((prevParams) => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
        }));
    };

    const dropdownRef = useRef(null);
    const handleOutsideClick = (event) => {
        if (showDropdown) {
            const target = event.target;
            const dropdownButton = document.querySelector('.clear-filter-button');
            const dropdownContent = document.querySelector('.s-field');
            const multiSelectInput = document.querySelector('.p-multiselect-filter');

            // Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
            if (
                !dropdownContent.contains(target) &&
                target !== dropdownButton &&
                target !== multiSelectInput &&
                !target.closest('.p-multiselect-item') && // MultiSelect items
                !target.closest('.p-dropdown-item') // Single select dropdown items
            ) {
                setShowDropdown(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showDropdown]);

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };


    return (
        <div className="group-table-component">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="header-design">
                <div>
                    {/* <h2>{customerControlFields?.display_name}</h2>
                    <p className="group-table-text-section">
                        Use this section to add and edit dropdown options for each question
                    </p> */}
                </div>
                {/* <ButtonElement className="upload-button" type="button" icon="pi pi-question" /> */}
            </div>
            <div className="group-table-buttons">
                <div className="delete-button">
                    {
                        updatedReferenceData.length > 0 &&
                        <ButtonElement
                            className="delete-button-icon"
                            type="button"
                            icon="pi pi-trash"
                            onClick={() => confirmDeleteProduct()}
                        />
                    }
                </div>
                {
                    !props.hideDataTable &&
                    <div className="group-table-search">
                        <HeaderSearchBar
                            value={searchQuery}
                            onChange={(e) => handleSearchChange(e)}
                            onClick={handleClearFilter}
                        />
                        <ButtonElement className="clear-filter-button" icon="pi pi-filter-slash" onClick={resetFilter} />
                        <div className='p-relative' ref={dropdownRef}>
                            <ButtonElement className="clear-filter-button" icon="pi pi-filter" onClick={toggleDropdown} />
                            {showDropdown && (
                                <>
                                    <div className='s-field'>
                                        <div className='new-field w-100'>
                                            {
                                                havingBranch && branchIdFromLS.branch_key == 'main' &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Branch:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedBranch}
                                                            optionLabel="branch_name"
                                                            options={branchDetails}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Client Type'] && _.find(clientFiltersNew, { filter_name: "Stakeholder Type" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[0].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedStakeholder}
                                                            optionLabel="label"
                                                            options={clientType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleStakeholderSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Client Classification'] && _.find(clientFiltersNew, { filter_name: "Stakeholder Classification" })?.status &&
                                                // filterPermissions['Client Classification'] (_.find(clientFiltersNew, { filter_name: "Stakeholder Classification" })?.status || 
                                                // _.find(clientFiltersNew, { filter_name: "Client Classification" })?.status) &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[1].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedClassification}
                                                            optionLabel="label"
                                                            options={clientClassificationType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleClassificationSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Primary Sector'] && _.find(clientFiltersNew, { filter_name: "Primary Sector" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[2].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedSector}
                                                            optionLabel="label"
                                                            options={sectorType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleSectorSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Main Board Sponsor'] && _.find(clientFiltersNew, { filter_name: "Main Board Sponsor" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[3].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedBoardSponser}
                                                            optionLabel="label"
                                                            options={relationshipOwner}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleBoardSponserSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Business Unit'] && _.find(clientFiltersNew, { filter_name: "Business Unit" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[4].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedBu}
                                                            optionLabel="label"
                                                            options={businessUnitType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleBUSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Region'] && _.find(clientFiltersNew, { filter_name: "Region" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[5].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedRegion}
                                                            optionLabel="label"
                                                            options={regionType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleRegionSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Stakeholder Status'] && _.find(clientFiltersNew, { filter_name: "Stakeholder Status" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[6].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedStatus}
                                                            optionLabel="label"
                                                            options={clientClassificationV3Type}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleStatusSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Relationship Owner'] && _.find(clientFiltersNew, { filter_name: "Relationship Owner" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[7].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedOwner}
                                                            optionLabel="label"
                                                            options={relationshipOwner}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleOwnerSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Favourites'] && _.find(clientFiltersNew, { filter_name: "Favourites" })?.status &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {filterData[8].display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <SingleSelectElement
                                                            value={selectedFavourites}
                                                            optionLabel="label"
                                                            options={(favourites != undefined && favourites.length > 0) ? favourites : []}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleFavouritesSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <ButtonElement
                            className="new-button"
                            type="button"
                            icon="pi pi-plus"
                            label="New"
                            onClick={() => show("right")}
                        />
                        <div>
                            <ButtonElement className="upload-button ml-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                        </div>
                    </div>

                }
            </div>
            <CreateNewStakeHolder custmerDetails={custmerDetails} branch={branchDetail} branchDetails={branchDetails} customerId={customerId} visible={visible} position={position} customerTableData={customerTableData} onHide={handleHide} relationshipOwner={relationshipOwner} clientFieldsNew={clientFieldsNew} commonFields={commonFields} currency={currency} havingBranch={havingBranch} branchIdFromLS={branchIdFromLS} clientSectionsNew={clientSectionsNew} />

            {
                !props.hideDataTable &&
                <DataTable
                    dataKey="_id"
                    value={stakeHolderDetails}
                    columns={columns}
                    removeField={removeField}
                    rowClick={editDirect}
                    isPrompts={true}
                    searchQuery={searchQuery}
                    onPage={onPage}
                    lazyParams={lazyParams}
                    totalRecords={totalRecords}
                    onSort={onSort}
                    deleted={deleted}
                />
            }
            <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={_.find(moduleNames, { module_name: "Clients" })?.display_name} modal footer={deleteProductDialogFooter()} onHide={hideDeleteProductDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <span className="table-description">
                        Are you sure you want to delete this {_.find(moduleNames, { module_name: "Clients" })?.display_name}? Deleting this {_.find(moduleNames, { module_name: "Clients" })?.display_name} will also delete associated addresses and contacts.
                    </span>
                </div>
            </Dialog>

            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_overview" />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}
